import * as React from 'react';
import { ProcessModel } from '../../../../Model/ProcessModel/ProcessModel';
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import ProcessButtons, {
  IProcessButton,
} from '../ProcessButtons/ProcessButtons';
import { IProcessWarning } from '../ProcessHeaderBase/ProcessHeaderBase';
import EDTypography from '../../../../BaseComponents/Typography/EDTypography';
import DatabaseAvatarList from '../../../../Components/DatabaseAvatarList/DatabaseAvatarList';
import { IDatabase } from '../../../Login/Contexts/LoginStateContext/LoginStateContext';

interface IProps {
  selectedProcess?: IProcessButton;
  onProcessSelected: (process: IProcessButton) => void;
  databases: IDatabase[];
  selectedDatabases: IDatabase[];
  warnings?: IProcessWarning[];
  allWarnings?: IProcessWarning[];
  onSelectDatabase: (db: IDatabase) => void;
  minimized: boolean;
  classes?: any;
}

const styles = (theme: Theme) => ({
  entityList: {
    display: 'flex',
    flex: '1 1 0%',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      flex: '0',
      justifySelf: 'flex-end',
      paddingLeft: 0,
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.customProperties.ProcessColors.processHeaderBg,
    margin: 0,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
  },
  headerText: {
    color: theme.customProperties.Fade.LightOnDark.highEmphasis,
  },
  minimizedHeaderText: {
    color: theme.customProperties.Fade.LightOnDark.lowEmphasis,
  },
  avatarLabelText: {
    color: theme.palette.primary.contrastText,
    paddingRight: theme.spacing(1),
  },
});

const checkWarningMessage = (
  p: IProcessButton,
  warnings?: IProcessWarning[]
) => {
  const warning = warnings && warnings.find(w => w.process === p.Kod);
  return warning && warning.message;
};

/**
 * Huvud headern i processträdet
 */
export class ProcessesHeader extends React.PureComponent<IProps> {
  render() {
    const { selectedProcess, databases } = this.props;
    return (
      <div className={this.props.classes.header}>
        {selectedProcess && (
          <div>
            <EDTypography
              variant={this.props.minimized ? 'subtitle1' : 'h5'}
              className={
                this.props.minimized
                  ? this.props.classes.minimizedHeaderText
                  : this.props.classes.headerText
              }
            >
              {`${selectedProcess.Kod}. ${selectedProcess.Benamning}`}
            </EDTypography>
            {/*!this.props.minimized && (
              <Typography
                variant="subtitle1"
                className={this.props.classes.headerText}
              >
                Stödprocess. Processägare: Camilla Edin
              </Typography>
            )*/}
          </div>
        )}
        <div className={this.props.classes.entityList}>
          <EDTypography className={this.props.classes.avatarLabelText}>
            Enheter:
          </EDTypography>
          <DatabaseAvatarList
            size={'small'}
            databases={databases}
            selectedDatabases={this.props.selectedDatabases}
            warnings={this.props.allWarnings}
            onClick={this.props.onSelectDatabase}
            showLabel
          />
          {selectedProcess && (
            <ProcessButtons
              content={ProcessModel.Processer.map(p => ({
                Kod: p.Kod,
                Benamning: p.Benamning,
                Warning: checkWarningMessage(p, this.props.warnings),
              }))}
              selected={selectedProcess}
              onSelect={this.props.onProcessSelected}
              buttonSize="small"
            />
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(ProcessesHeader, styles);
